'use client';

import { ErrorUI } from '@web/ui';

import type { ErrorPageProps } from '@web/types';

export default function Error({ error, reset }: ErrorPageProps) {
  return (
    <ErrorUI
      title="Something went wrong at the Workspace page"
      message={error.message}
      onAction={reset}
    />
  );
}
